// react
import React from 'react';

// third-party
import { Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import HomePage from './home/HomePage';

// application
import Footer from './footer';
import Header from './header';

import catalogos from '../data/catalogos';
import { typeTraslate } from '../data/enums';
import Catalogo from './shared/Catalogos';
import { _path } from '../data/headerNavigation';
import PrivateRoute from './header/PrivateRouter';
import Paciente from './search/Paciente';
import Procedimientos from '../views/services';
import OutPutProducts from '../views/movimientos/outPutProducts';
import InPutProducts from '../views/movimientos/inPutProducts';
import Products from '../views/products';
import Users from '../views/users';
import Roles from '../views/roles';
import Resources from '../views/resources';
import Rates from '../views/rates';
import initProduct from '../views/movimientos/initProducts/initProduct';
import initPurchases from '../views/movimientos/initProducts/initPurchases';
import Providers from '../views/providers/Providers';
import Traslates from '../views/movimientos/traslates';
import Kardex from '../views/reports/kardex';
import Existencias from '../views/reports/stocks';
import initAdjustments from '../views/movimientos/initProducts/initAdjustments';
import Clients from '../views/clients';
import Bills from '../views/bills';
import Receipts from '../views/receipts';
import Areas from '../views/areas';
import Vendors from '../views/vendors/Vendors';
import Stock from '../views/reports/stocks/Stock';
import NuevoQuickly from '../views/bills/NuevoQuickly';
import Navig from './navigator/Navig';
import AppConfig from '../views/app/AppConfig';
import Comision from '../views/reports/facturas/Comision';
import ProductsInfo from '../views/reports/facturas/ProductsInfo';
import Clasifications from '../views/clasifications';
import Pending from '../views/clients/Pending';
import MobileMenu from './mobile/MobileMenu';
import MobileHeader from './mobile/MobileHeader';

function Layout(props) {
    const { headerLayout } = props;

    const PrintCatalogos = catalogos.map(c => {
        return  <PrivateRoute key={c.name} exact path={`${_path.ROOTMAIN}/${c.name}`} render={(props) => (
                    <Catalogo {...props} {...c} />
        )} />
    });

    let prop = (path, component) => ({exact:true, path : `${_path.ROOTMAIN}/${path}`, component });

    const builRoute = (path, component) => <PrivateRoute key={path} {...prop(path, component) } /> ;

    const routes = [
        builRoute('', HomePage)     
        ,builRoute('areas', Areas)     
        ,builRoute('clasificaciones', Clasifications)     
        ,builRoute('paciente/:id', Paciente)
        ,builRoute('procedimientos', Procedimientos)       
        ,builRoute('facturas', Bills)       
        ,builRoute('facturas-quickly', NuevoQuickly)       
        ,builRoute('vendedores', Vendors)       
        ,builRoute('recibos', Receipts)       
        ,builRoute('clientes', Clients)       
        ,builRoute('clientes/pending', Pending)       
        ,builRoute('movimientos/entradas', initAdjustments)
        ,builRoute('movimientos/salidas', OutPutProducts)
        ,builRoute('movimientos/entradas', InPutProducts)
        ,builRoute('movimientos/inv-inicial', initProduct)
        ,builRoute('movimientos/compras', initPurchases)
        ,builRoute('productos', Products)
        ,builRoute('tasa-de-cambio', Rates)
        ,builRoute('proveedores', Providers)
        ,builRoute('usuarios', Users)
        ,builRoute('roles', Roles)
        ,builRoute('permisos', Resources)
        ,builRoute('inventario/reportes/kardex', Kardex)
        ,builRoute('inventario/reportes/existencias', Existencias)
        ,builRoute('inventario/reportes/stock', Stock)
        ,builRoute('facturas/reportes/comisiones', Comision)
        ,builRoute('facturas/reportes/productos-consolidados', ProductsInfo)

        ,builRoute('navig', Navig)
        ,builRoute('config', AppConfig)
        
    ];
    return (
        <React.Fragment>          

            <ToastContainer autoClose={5000} hideProgressBar />

            <MobileMenu layout={headerLayout}/>

            <div className="site">
                <header className="site__header d-lg-none">
                    <MobileHeader />
                </header>

                <header className="site__header d-lg-block d-none">
                    <Header layout={headerLayout} />
                </header>

                <div className="site__body">
                
                    <Switch>
                        {PrintCatalogos}    
                        {routes}   
                        <PrivateRoute key={1} exact path={`${_path.ROOTMAIN}/movimientos/traslados`} render={props => <Traslates {...props} type={typeTraslate.create} /> } />                         
                        <PrivateRoute key={2} exact path={`${_path.ROOTMAIN}/movimientos/despacho`} render={props => <Traslates {...props} type={typeTraslate.update}/> } />                            

                    </Switch>
                </div>

                <footer className="site__footer">
                    <Footer showInfo={true} />
                </footer>
            </div>
        </React.Fragment>

    )
}

export default Layout;

